import React from 'react';
import { bool, func, oneOfType, string } from 'prop-types';
import classNames from 'classnames';

import { ensureUser, ensureCurrentUser } from '../../../util/data';
import { propTypes } from '../../../util/types';
import { AvatarLarge, NamedLink } from '../../../components';
import Icons from '../../../components/Icons/Icons';

import css from './UserCard.module.css';
import { formatTelLink, normalizeUrl } from '../../../util/genericHelpers';

const UserCard = props => {
  const { rootClassName, className, user, subscriptionName } = props;

  const userIsCurrentUser = user && user.type === 'currentUser';
  const ensuredUser = userIsCurrentUser ? ensureCurrentUser(user) : ensureUser(user);

  if (!ensuredUser.id) {
    return null;
  }

  const profile = ensuredUser.attributes.profile || {};
  const publicData = profile.publicData || {};

  const displayName = profile.displayName || '';
  const phoneNumber =
    publicData.phone_number || publicData.businessPhone || publicData.contactPhone || '';
  const website = publicData.website || publicData.websiteUrl || publicData.url || '';

  const classes = classNames(rootClassName || css.root, className);

  const hasPhone = !!phoneNumber;
  const hasWebsite = !!website;

  return (
    <div className={classes}>
      <div className={css.content}>
        <AvatarLarge className={css.avatar} user={user} />

        <div className={css.info}>
          {/* Name */}
          <div className={css.headingRowSimple}>{displayName}</div>

          {subscriptionName ? (
            <>
              {/* Phone */}
              {hasPhone ? (
                <p className={css.phone}>
                  <a href={formatTelLink(phoneNumber)}>{phoneNumber}</a>
                </p>
              ) : null}

              {/* Website */}
              {hasWebsite ? (
                <a
                  href={normalizeUrl(website)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={css.website}
                >
                  {website}
                </a>
              ) : null}
            </>
          ) : null}

          <p className={css.phone}>
            {' '}
            <NamedLink
              className={css.viewAllListingsLink}
              name="ProfilePage"
              params={{ id: ensuredUser.id.uuid }}
            >
              <span className={css.viewAllListingsText}>View all listings</span>
            </NamedLink>
          </p>
        </div>
      </div>
    </div>
  );
};

UserCard.defaultProps = {
  rootClassName: null,
  className: null,
  user: null,
  currentUser: null,
  showContact: true,
};

UserCard.propTypes = {
  rootClassName: string,
  className: string,
  user: oneOfType([propTypes.user, propTypes.currentUser]),
  // kept for backwards compatibility (even though we don't use them now)
  currentUser: propTypes.currentUser,
  onContactUser: func,
  showContact: bool,
};

export default UserCard;
